function resolveApiBase(): string {
  const fromEnv = import.meta.env.VITE_API_BASE;
  if (fromEnv) return fromEnv.replace(/\/$/, "");
  if (import.meta.env.DEV) return "/api";
  const path = window.location.pathname.replace(/\/index\.html$/i, "");
  const dir = path.endsWith("/") ? path.slice(0, -1) : path;
  return `${dir}/api`;
}

export const API_BASE = resolveApiBase();
